/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("ModelAddToOrderController", [
            "$scope", "$http", "$sessionStorage", "$location", "$shoppingCart", "model", "$oidc",
            function ($scope, $http, $sessionStorage, $location, $shoppingCart, model, oidc) {
                $scope.$storage = $sessionStorage;

                $scope.order = {
                    model: model,
                    quantity: 1
                };

                $scope.addToOrder = function () {
                    for (var index = 0; index < $scope.order.quantity; index++) {
                        $shoppingCart.add({
                            type: "Model",
                            data: $scope.order.model
                        });
                    }
                    $scope.$close();
                };

                $http.get("/api/model-eta-catalog/" + $scope.order.model.ModelColorId + "/bonus-exists", {
                    params: {
                        retailerId: $scope.$storage.retailer.Id
                    },
                    headers: {
                        Authorization: oidc.current.token_type + " " + oidc.current.access_token
                    }
                }).then(function (response) {
                    $scope.order.bonusExists = response.data.Exists;
                });

                // Redirect to bonus cars
                $scope.openBonusCars = function () {
                    $location.url("/bonus-cars?ModeNameId=" + $scope.order.model.ModelNameId);
                    $scope.$close();
                };
            }
        ]);
})();